import {CargoTypes, CargoTypesResponse} from '../types/models/cargo-types'
import {ProgramInfo, ProgramInfoResponse} from '../types/models/program-info'
import Api from '../classes/api'

interface ErrorInterface {
    errors: string[]
}

export default async function getInfo() {
    try {
        const programInfo: ProgramInfoResponse = await Api.getProgramInfo()
        const cargoTypes: CargoTypesResponse = await Api.getCargoTypes()
        // typeGuard совмещённый с проверкой на ошибки
        // сюда б по-хорошему модалочку пихнуть
        if ((programInfo as ErrorInterface).errors || (cargoTypes as ErrorInterface).errors) {
            return null
        } else {
            const info = {
                programInfo: programInfo as ProgramInfo,
                cargoTypes: cargoTypes as CargoTypes,
            }
            return info
        }
    } finally {
    }
}
